import { render, staticRenderFns } from "./ShareScreenMenu.vue?vue&type=template&id=66cc4516&scoped=true"
import script from "./ShareScreenMenu.vue?vue&type=script&lang=js"
export * from "./ShareScreenMenu.vue?vue&type=script&lang=js"
import style0 from "./ShareScreenMenu.vue?vue&type=style&index=0&id=66cc4516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc4516",
  null
  
)

export default component.exports